export enum ModalTypes {
  AmendAppointment = 'amendAppointmentModal',
  PONRModal = 'PONRModal',
  OrderDetails = 'orderDetailsModal',
  Loading = 'loadingModal',
  LoadingWhileAmending = 'loadingWhileAmending',
}
